import type {Module} from "vuex";
import type {RootState} from "@/store/types";
import {useStorage} from "@/api/storage/local";

// Profile quiz answers, kept in storage
export type QuizProfileModel = Record<string, unknown>

export interface QuizProfileState {
    model: QuizProfileModel
}

const STORAGE_KEY = "quiz_profile";

const profile: Module<QuizProfileState, RootState> = {
    namespaced: true,
    state: {
        model: {}
    },
    getters: {
        model: (state): QuizProfileModel => state.model
    },
    mutations: {
        setModel: (state, model: QuizProfileModel) => state.model = model,
        updateStorage: state => useStorage()!.set(STORAGE_KEY, state.model)
    },
    actions: {
        // Without a model, loads the one saved in storage
        fetch(context, model?: QuizProfileModel) {

            model = model || useStorage()!.get(STORAGE_KEY, {});
            context.commit("setModel", model);
        },
        setModel(context, model: QuizProfileModel) {

            context.commit("setModel", model);
            context.commit("updateStorage");
        },
        clear(context) {

            context.commit("setModel", {});
            context.commit("updateStorage");
        }
    }
}

export default profile
